import React from 'react';
import './Board.css';

const Board = ({ board }) => {
  return (
    <div className="board">
      {board.map((row, y) => (
        <div key={y} className="row">
          {row.map((cell, x) => (
            <div
              key={x}
              className="cell"
              style={{ backgroundColor: cell }}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Board;
